import React from "react";

const copy = {
  terms: {
    title: "Terms & Conditions",
    body: [
      {
        heading: "Business identity and relationship",
        text: "CRACKERS MART operates the website https://hyderabadcrackers.co.in/ under the store name Hyderabad Crackers. Hyderabad Crackers is the online storefront through which CRACKERS MART displays and sells crackers. CRACKERS MART is the seller responsible for orders placed through this website, including order fulfilment, delivery, and customer support. References on this website to “Hyderabad Crackers,” “we,” or “us” refer to CRACKERS MART.",
      },
      {
        text: "By placing an order, you confirm that you are at least 18 years old and that delivery is permitted at your address. Orders are fulfilled subject to stock availability, payment confirmation, and applicable laws. Please use fireworks responsibly and follow all local safety guidance.",
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      {
        text: "We use your contact, delivery, and order details only to provide customer support, fulfil orders, and improve the store. We do not sell your personal information. You can contact us to request access to or deletion of your account information.",
      },
    ],
  },
};

export default function LegalPage({ type }) {
  const page = copy[type];

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-extrabold">{page.title}</h1>
      <div className="mt-4 space-y-5 text-sm leading-7 text-hyd-text2">
        {page.body.map(({ heading, text }) => (
          <section key={heading || text}>
            {heading && <h2 className="mb-1 font-bold text-hyd-text">{heading}</h2>}
            <p>{text}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
